import { Component } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EnvironmentService } from './app/@core/services/environment.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
  constructor(private translate: TranslateService, private meta: Meta, private envService: EnvironmentService) {
    if (this.envService.production === false) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
    let storedLang = localStorage.getItem('selectedLanguage');
    if (storedLang) {
      if (storedLang !== 'it') {
        // DISATTIVO LINGUA INGLESE PROVVISORIAMENTE
        storedLang = 'it';
        localStorage.setItem('selectedLanguage', 'it');
      }
      this.translate.use(storedLang);
    } else {
      // DISATTIVO LINGUA INGLESE PROVVISORIAMENTE
      // const browserLang = this.translate.getBrowserLang();
      // const defaultLang = browserLang?.match(/it|en/) ? browserLang : 'it';
      const defaultLang = 'it';
      this.translate.use(defaultLang);
      localStorage.setItem('selectedLanguage', defaultLang);
    }
  }
}
